// extracted by mini-css-extract-plugin
module.exports = {"btn-root":"Button_btn-root__2nZSG","primary":"Button_primary__1VZL1","text":"Button_text__3rm0G","outline":"Button_outline__3UI3L"};